import React from 'react';
import { Calendar, Phone, Check } from 'lucide-react';
import { Button } from './ui/button';
import { finalCTA } from '../data/mock';
import { useAppointment } from '../context/AppointmentContext';

const FinalCTA = () => {
  const { openAppointmentModal } = useAppointment();
  
  return (
    <section className="py-24 bg-gradient-to-br from-[#1B1B3A] via-[#2D2D4A] to-[#1B1B3A] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#E63946] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#20B2AA] rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight">
            {finalCTA.headline}
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed">
            {finalCTA.subheadline}
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center mb-16">
            <Button 
              size="lg" 
              className="bg-[#E63946] text-white hover:bg-[#D32F3D] text-lg px-10 py-7 shadow-2xl font-bold"
              onClick={openAppointmentModal}
              data-testid="cta-schedule-btn"
            >
              <Calendar className="mr-3 h-6 w-6" />
              {finalCTA.primaryCTA}
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-3 border-white text-white hover:bg-white hover:text-[#1B1B3A] text-lg px-10 py-7 font-bold"
              asChild
            >
              <a href="tel:+14043552728">
                <Phone className="mr-3 h-6 w-6" />
                {finalCTA.secondaryCTA}
              </a>
            </Button>
          </div>

          <div className="grid md:grid-cols-4 gap-6">
            {finalCTA.trustPoints.map((point, idx) => (
              <div key={idx} className="flex items-center justify-center gap-3 text-white">
                <Check className="h-6 w-6 text-[#20B2AA] flex-shrink-0" />
                <span className="text-lg font-medium">{point}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
